import _regeneratorRuntime from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _objectSpread from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
// import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import LangSelect from '@/components/LangSelect';
import ClientSelect from '@/components/ClientSelect';
import SystemMessage from '@/components/SystemMessage';
import request from '@/utils/request';
export default {
  data: function data() {
    return {
      modifyPassDialogVisible: false,
      oldPass: null,
      newPass: null
    };
  },
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    // ErrorLog,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    LangSelect: LangSelect,
    ClientSelect: ClientSelect,
    SystemMessage: SystemMessage
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'roles', 'name', 'username'])), {}, {
    canSelectClient: function canSelectClient() {
      return this.roles.includes('admin') || this.roles.includes('系统管理员');
    }
  }),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logoutConfirm: function logoutConfirm() {
      var _this = this;
      this.$confirm(this.$t('navbar.logOut') + '?', this.$t('common.info'), {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.no'),
        type: 'warning'
      }).then(function () {
        _this.logout();
      }).catch(function () {});
    },
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              this.$router.push('/login');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    confirmModifyPass: function confirmModifyPass() {
      var _this2 = this;
      var oldPass = this.oldPass;
      var newPass = this.newPass;
      if (isNull(oldPass) || isNull(newPass)) {
        this.$message.warning(this.$t('rules.common.cannotEmpty'));
        return;
      }
      request({
        url: 'user/modify-password',
        method: 'post',
        data: {
          old_password: oldPass,
          new_password: newPass
        }
      }).then(function (response) {
        if (response.data.code === '0') {
          _this2.$message.success(response.data.message);
          _this2.modifyPassDialogVisible = false;
          _this2.logout();
        } else {
          _this2.$message.error(response.data.message);
        }
      });
    },
    modifyPass: function modifyPass() {
      this.modifyPassDialogVisible = true;
    }
  }
};